import { useCallback } from 'react';
import { useAuthStore } from '@/Stores/auth-v2-store';

export const usePermissions = () => {
  const { hasPermission, hasAnyPermission, currentUser } = useAuthStore();

  const can = useCallback(
    (permission: string) => hasPermission(permission),
    [hasPermission]
  );

  const canAny = useCallback(
    (permissions: string[]) => hasAnyPermission(permissions),
    [hasAnyPermission]
  );

  const canAll = useCallback(
    (permissions: string[]) => permissions.every(p => hasPermission(p)),
    [hasPermission]
  );

  return {
    can,
    canAny,
    canAll,
    permissions: currentUser?.permissions || [],
  };
};
